import {
    DEFAULT_CURRENCY,
    DEFAULT_QUANTITY,
    normalizeCommitmentType,
    normalizeNumber,
    normalizeSegment,
} from '../../core/normalizers';
import type { TrackingCommerce, TrackingItem } from '../../types';
import { GTMItemServiceType, GTMItemType, GTMOrderType } from '../../types';
import type { PublicServicePlanEventData, PublicServicePlanSource } from './types';

const mapPublicServicePlanToTrackingItem = (
    plan: PublicServicePlanSource,
    index: number,
    serviceType?: GTMItemServiceType | '',
): TrackingItem => {
    const price = normalizeNumber(plan.price);
    const regularVariant = plan.dataSizeDomesticTotalFormatted || '';

    return {
        type: GTMItemType.Product,
        id: plan.code || '',
        name: plan.name || '',
        brand: 'Telia',
        variant: [plan.cap?.name, regularVariant].filter(Boolean).join(' '),
        category: plan.offerGroup || '',
        listId: plan.uniqueOfferId || '',
        listName: plan.offerGroup || '',
        index,
        originalPrice: normalizeNumber(plan.priceStandard) || price,
        price,
        nboDiscount: 0,
        nboOffer: Boolean(plan.nboId),
        discount: 0,
        quantity: DEFAULT_QUANTITY,
        serviceType: serviceType || '',
        commitmentType: normalizeCommitmentType(plan.contractDuration),
        previousPlan: '',
        previousOperator: '',
    };
};

export const mapPublicServicePlansToTrackingCommerce = ({
    index: selectedIndex,
    plans,
    serviceType,
}: PublicServicePlanEventData): TrackingCommerce => ({
    orderType: GTMOrderType.Services,
    segment: plans[0]?.segment ? normalizeSegment(plans[0].segment) : '',
    currency: DEFAULT_CURRENCY,
    value: 0,
    itemListName: plans[0]?.offerGroup,
    giftIncluded: false,
    coupon: '',
    paymentType: '',
    paymentMethod: '',
    signMethod: '',
    bank: '',
    transactionId: '',
    items: plans.map((plan, index) =>
        mapPublicServicePlanToTrackingItem(
            plan,
            plans.length === 1 && selectedIndex !== undefined ? selectedIndex : index,
            serviceType,
        ),
    ),
});

export const mapPublicServicePlanLeadModalToTrackingCommerce = (
    plan: PublicServicePlanSource,
    index: number,
): TrackingCommerce => ({
    ...mapPublicServicePlansToTrackingCommerce({ plans: [plan], serviceType: GTMItemServiceType.NewSale }),
    items: [mapPublicServicePlanToTrackingItem(plan, index, GTMItemServiceType.NewSale)],
});
